import type {
  BooleanFlag,
  CategoryConfig,
  CustomButton,
  EditConfigAuthor,
  EditConfigCopyright,
  EditConfigCustomIcons,
  EditConfigLoading,
  EditConfigSandTable,
  EditConfigUI,
  EnterCover,
  GeneralID,
  GlobalFlags,
  Logo,
  SceneConfigFirstSceneButton,
  Subtitle,
  TagLine,
  TourTip,
} from '@types';
import { createApi, createDomain } from 'effector';
import { createGate } from 'effector-react';

const domain = createDomain('editing');

const createEditingStore = <T>(initial: T) => {
  const store = domain.store<T>(initial);
  const api = createApi(store, {
    set: (_, payload: T) => payload,
  });
  return { store, api };
};

export const $editingEnterCover = createEditingStore<EnterCover>({});
export const $editingTourTip = createEditingStore<TourTip>({});
export const $editingHiddenIdSet = createEditingStore<Set<GeneralID>>(
  new Set()
);

export const $editingFlag = createEditingStore<GlobalFlags | null>(null);
export const $editingFirstSceneButton =
  createEditingStore<SceneConfigFirstSceneButton | null>(null);
export const $editingLogo = createEditingStore<Logo | null>(null);
export const $editingLangFlag = createEditingStore<BooleanFlag | null>(null);
export const $editingCategoryConfig = createEditingStore<CategoryConfig | null>(
  null
);
export const $editingCustomButton = createEditingStore<CustomButton[] | null>(
  null
);
export const $editingCopyright = createEditingStore<EditConfigCopyright | null>(
  null
);
export const $editingUIColor = createEditingStore<EditConfigUI | null>(null);

export const $GateSandTable = createGate<EditConfigSandTable | null>({
  defaultState: null,
  domain,
});
export const $GateSandTableId = createGate<string | null>({
  defaultState: null,
  domain,
});

export const $GateConfigLoading = createGate<EditConfigLoading | null>({
  defaultState: null,
  domain,
});

export const $GateSubtitleList = createGate<Subtitle[]>({
  defaultState: [],
  domain,
});
export const $GateEditingSubTitle = createGate<Subtitle | null>({
  defaultState: null,
  domain,
});
export const $GateTagLineList = createGate<TagLine[]>({
  defaultState: [],
  domain,
});
export const $GateEditingTagLine = createGate<TagLine | null>({
  defaultState: null,
  domain,
});
export const $GateSearchBtn = createGate<boolean | null>({
  defaultState: null,
  domain,
});

export const $GateEditingCustomIcons = createGate<EditConfigCustomIcons | null>(
  {
    defaultState: null,
    domain,
  }
);
export const $GateEditingLikeBtnActive = createGate<boolean | null>({
  defaultState: null,
  domain,
});
export const $GateEditingAuthor = createGate<EditConfigAuthor | null>({
  defaultState: null,
  domain,
});
